/**
 * App slide-outs beside the AVA side panel: a right-docked <slide-out> (Edit Task, Task Filters)
 * ends at the chat's left edge instead of covering it, mask included, so the chat stays usable.
 * The width is the one the assistant publishes as ASSISTANT_INSET_VAR (AvaAssistant's `inset`):
 * the live panel width while it is an open side panel, 0px when it is closed, a drawer, a page or
 * full-screen, so those cases keep the library default.
 * No Vue or path-alias imports, so `npm run test:unit` (node --test) can load it directly.
 */
import { ASSISTANT_INSET_VAR } from '../constants/assistant.constants.js';

/** CSS `right` that follows the side panel's width as the user resizes, closes or reopens it. */
export const BESIDE_PANEL_RIGHT = `var(${ASSISTANT_INSET_VAR}, 0px)`;

/**
 * Inline style for a <slide-out> root (it holds both the mask and the panel). The panel keeps its
 * size and resize; the library's `max-width: 100%` on it stops it at the left edge of what is left.
 * A nested slide-out lives inside another panel that is already beside the chat, so it is left alone.
 * @param {{ dock?: string, nested?: boolean }} [options] dock defaults to the library's 'right'
 * @returns {{ right?: string }}
 */
export function besidePanelStyle({ dock = 'right', nested = false } = {}) {
  return dock === 'right' && !nested ? { right: BESIDE_PANEL_RIGHT } : {};
}
